
import React from 'react';
import { useLanguage } from '../../contexts/language';
import { formatCurrencyShort } from '../../data/utils/money-utils';
import { Region } from '../../data/types/region-types';

interface TotalPledgesProps {
  regions: Region[];
  selectedRegion: Region | null;
  isGlobalView: boolean;
  isMexicoView: boolean;
}

const TotalPledges: React.FC<TotalPledgesProps> = ({
  regions,
  selectedRegion,
  isGlobalView,
  isMexicoView,
}) => {
  const { t } = useLanguage();
  
  // Don't show anything if we're in region view
  if (selectedRegion) {
    return null;
  }

  const calculateTotalPledges = () => {
    if (isGlobalView) {
      // Calculate global total from all regions
      return regions.reduce((total, region) => total + (region.pledges || 0), 0);
    }
    
    if (isMexicoView) {
      // Calculate Mexico total from Mexican regions only
      const mexicoRegions = regions.filter(region => 
        ['CDMX', 'CHIS', 'HGO'].includes(region.region_id)
      );
      return mexicoRegions.reduce((total, region) => total + (region.pledges || 0), 0);
    }

    return 0;
  };

  const totalPledges = calculateTotalPledges();
  const viewLabel = isGlobalView ? 'Global' : isMexicoView ? 'Mexico' : '';
  
  // Hide when in region view
  if (selectedRegion) return null;

  return (
    <div className="mt-4 p-3 bg-white/90 backdrop-blur-sm rounded-lg border border-blue-100">
      <div className="text-sm text-[#0E4D66]">
        <span className="font-medium">{viewLabel} Total Pledges:</span>
        <div className="font-nasalization text-lg mt-1">
          {formatCurrencyShort(totalPledges)}
        </div>
      </div>
    </div>
  );
};

export default TotalPledges;
